import { useSelector } from "react-redux";

import { boxContainer, application, Spacer } from "../../components";

import { Images } from "../../config";

const StudentApplications = () => {
  const { student } = useSelector((state) => state?.students);

  const topData = [
    {
      title: "Total Applications",
      value: student?.applications?.totalApplications ?? 0,
      icon: Images?.StudentApplicationTotal,
    },
    {
      title: "Recommendation Requests",
      value: student?.applications?.recommendationCount ?? 0,
      icon: Images?.StudentGeneralCountryPref,
    },
    {
      title: "Countries Applied To",
      value: student?.applications?.countryCount ?? 0,
      icon: Images?.StudentGeneralCountryPref,
    },
    {
      title: "Universities Applied To",
      value: student?.applications?.uniCount ?? 0,
      icon: Images?.StudentGeneralDegreePref,
    },
  ];

  return (
    <div className="px-6 py-4">
      <div className="flex gap-6 w-full justify-between">
        {topData?.map((item, index) => (
          <boxContainer.LiteBoxContainer key={index} addstyle="flex flex-1">
            <div className="flex flex-col gap-2 px-2 w-full">
              <div className="student-box-title text-dot" title={item?.title}>
                {item?.title}
              </div>
              <div className="flex justify-between items-center">
                <div className="text-dot student-box-value" title={item?.value}>
                  {item?.value}
                </div>
                <img src={item?.icon} className="h-[2em]" />
              </div>
            </div>
          </boxContainer.LiteBoxContainer>
        ))}
      </div>
      <Spacer height={20} />
      <div className="student-headers">Applications in Progress</div>
      <Spacer height={20} />
      <div className="max-h-[37.5em] overflow-auto flex flex-col gap-4">
        {student?.applications?.appsInProgress?.map((item, index) => (
          <application.ApplicationRowInProgress item={item} key={index} />
        ))}
      </div>
      <Spacer height={20} />
      <div className="student-headers">Submitted Applications</div>
      <Spacer height={20} />
      <div className="max-h-[37.5em] overflow-auto flex flex-col gap-4">
        {student?.applications?.appsSubmitted?.map((item, index) => (
          <application.ApplicationRowSubmitted item={item} key={index} />
        ))}
      </div>
    </div>
  );
};

export default StudentApplications;
